













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModuleFooterList extends Vue {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly list!: Array<string>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulefooter/components/modulefooterlist/ModuleFooterList.vue